import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class GenerateEpubPreviewDto {
  // Ignored by the server, which cuts the book's own epub, as is convertFromLocalFile below [sc-28919]. The author
  // app still sends the name it loaded the epub from to pick the cut.
  @Field()
  epubFileName!: string

  @Field(t => Int)
  bookId!: number

  @Field()
  cutAtCfi!: string

  @Field()
  lastPageBodyHtml!: string

  @Field()
  lastPageUrl!: string

  @Field()
  convertFromLocalFile?: boolean
}
